/**
 * Customized to align react styles
 */

import { SxProps, Theme } from '@mui/material';

export const AAFieldItemSX: SxProps<Theme> = {
	// Input base
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: 'primary.light',
	},
	'& .MuiOutlinedInput-root': {
		color: 'grey.500',
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.light',
		},
		'&.Mui-error .MuiOutlinedInput-notchedOutline': {
			borderColor: 'grey.200',
			borderBottom: '2px solid',
			borderBottomColor: 'error.main',
		},
		'&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.light',
		},
	},
	// Label base
	'& .MuiInputLabel-root': {
		color: 'grey.200',
		'&.Mui-error': {
			color: 'grey.200',
			'&:hover + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
				borderColor: 'primary.light',
			},
		},
	},

	// Helper text on error
	'& .MuiFormHelperText-root.Mui-error': {
		ml: 0,
	},
};

export const AAFieldItemInputSX: SxProps<Theme> = {
	// Input base
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: 'primary.light',
	},
	'& .MuiOutlinedInput-root': {
		color: 'grey.500',
		'&:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.light',
		},
		'&.Mui-error .MuiOutlinedInput-notchedOutline': {
			borderColor: 'grey.200',
			borderBottom: '2px solid',
			borderBottomColor: 'error.main',
		},
		'&.Mui-error:hover .MuiOutlinedInput-notchedOutline': {
			borderColor: 'primary.light',
		},
	},
};

export const AAFieldItemLabelSX: SxProps<Theme> = {
	// Label base
	'& .MuiInputLabel-root': {
		color: 'grey.200',
		'&.Mui-error': {
			color: 'grey.200',
			'&:hover + .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
				borderColor: 'primary.light',
			},
		},
	},

	// Helper text on error
	'& .MuiFormHelperText-root.Mui-error': {
		ml: 0,
	},
};

export const AAFormSelectSX: SxProps<Theme> = {
	'& .MuiSelect-select': {
		color: 'grey.200',
	},
	'& .MuiSelect-icon': {
		transform: 'rotate(90deg)',
		transition: 'transform 0.2s ease',
	},
	'& .MuiSelect-iconOpen': {
		transform: 'rotate(-90deg)',
	},
};

export const AANoExteriorNumberCheckboxSX: SxProps<Theme> = {
	p: 0,
	mr: '5px',
	color: 'grey.200',
	'&.Mui-checked': {
		color: 'grey.500',
	},
};

export const AANoExteriorNumberLabelSX: SxProps<Theme> = {
	ml: 0,
	mr: 0,
	py: '5px',
	'& .MuiFormControlLabel-label': {
		fontSize: '14px',
		color: 'secondary.main',
	},
};

export const AANoExteriorNumberTwoColumnsSX: SxProps<Theme> = {
	pb: { md: 0 },
};
